import { render, staticRenderFns } from "./AdminLayoutBasic.vue?vue&type=template&id=59911f24&scoped=true"
import script from "./AdminLayoutBasic.vue?vue&type=script&lang=js"
export * from "./AdminLayoutBasic.vue?vue&type=script&lang=js"
import style0 from "./AdminLayoutBasic.vue?vue&type=style&index=0&id=59911f24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59911f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59911f24')) {
      api.createRecord('59911f24', component.options)
    } else {
      api.reload('59911f24', component.options)
    }
    module.hot.accept("./AdminLayoutBasic.vue?vue&type=template&id=59911f24&scoped=true", function () {
      api.rerender('59911f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/AdminLayoutBasic.vue"
export default component.exports